module.exports = __webpack_public_path__ + "img/product-preview-66.76904e8.png";